<div class="tw-text-l1 tw-text-danger">
    <ng-content></ng-content>
</div>